import { Routes } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { PageNotFoundComponent } from './views/page-not-found/page-not-found.component';
import { NotificationsComponent } from './views/notifications/notifications.component';
import { MessageComponent } from './views/message/message.component';
import { UserProfileComponent } from './views/user-profile/user-profile.component';
import { OrderOverviewComponent } from './views/order-overview/order-overview.component';
import { CoilOverviewComponent } from './views/coil-overview/coil-overview.component';
import { LandingPageComponent } from './views/landing-page/landing-page.component';
import { AgreementComponent } from './views/agreement/agreement.component';
import { MsalGuard } from '@azure/msal-angular';
import { SupportComponent } from './views/support/support.component';
import { SettingsComponent } from './views/settings/settings.component';
import { WhereIsSteelComponent } from './views/where-is-steel/where-is-steel.component';


export const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full', canActivate: [MsalGuard] },
  { path: 'notifications', component: NotificationsComponent },
  { path: 'orders', component: OrderOverviewComponent, canActivate: [MsalGuard] },
  { path: 'coils', component: CoilOverviewComponent, canActivate: [MsalGuard] },
  // { path: 'login', component: LoginComponent },
  // { path: 'register', component: RegisterComponent },
  { path: 'notify', component: MessageComponent },
  { path: 'demo', component: LandingPageComponent },
  // { path: 'dform', component: DemoFormComponent },
  // { path: 'dthanks', component: DemoThanksComponent },
  { path: 'agreement', component: AgreementComponent, canActivate: [MsalGuard]},
  { path: 'activate', component: MessageComponent },
  { path: 'user-profile', component: UserProfileComponent, canActivate: [MsalGuard] },
  { path: 'settings', component: SettingsComponent },
  { path: 'where-is-my-steel', component: WhereIsSteelComponent },
  { path: 'support', component: SupportComponent},
  { path: '**', component: PageNotFoundComponent }
];
